import { useState, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AmbassadorCard from "./AmbassadorCard";

export default function AmbassadorTab({
  ambassadors,
  selectedAmbassadors,
  onToggle,
  hideSearch = false,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [ticketFilter, setTicketFilter] = useState("all");

  const filteredAmbassadors = useMemo(() => {
    let filtered = ambassadors;

    // Filter by search term (solo si no está oculto)
    if (searchTerm && !hideSearch) {
      filtered = filtered.filter((amb) =>
        (amb.nombre || amb.name || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase()),
      );
    }

    // Filter by tickets sold
    if (ticketFilter !== "all") {
      filtered = filtered.filter((amb) => {
        const tickets = amb.ticketsVendidos || 0;
        switch (ticketFilter) {
          case "0-10":
            return tickets >= 0 && tickets <= 10;
          case "11-50":
            return tickets >= 11 && tickets <= 50;
          case "51-100":
            return tickets >= 51 && tickets <= 100;
          case "100+":
            return tickets > 100;
          default:
            return true;
        }
      });
    }

    return filtered;
  }, [ambassadors, searchTerm, ticketFilter, hideSearch]);

  return (
    <>
      <div className="w-full space-y-4">
        {/* Search and Filter Controls */}
        {!hideSearch && (
          <div className="flex flex-col sm:flex-row gap-3">
            {/* Search Input */}
            <div className="flex-1 relative">
              <FontAwesomeIcon
                icon="fa-solid fa-search"
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
              />
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Buscar por nombre..."
                className="w-full pl-10 pr-4 py-2 bg-aw-bluedark border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-aw-green transition duration-300"
              />
            </div>
          </div>
        )}

        {/* Ticket Filter Dropdown */}
        {/* <div className="sm:w-48 relative">
          <FontAwesomeIcon
            icon="fa-solid fa-filter"
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
          />
          <select
            value={ticketFilter}
            onChange={(e) => setTicketFilter(e.target.value)}
            className="w-full pl-10 pr-4 py-2 bg-aw-bluedark border border-gray-600 rounded-lg text-white focus:outline-none focus:border-aw-green transition duration-300 appearance-none cursor-pointer"
          >
            <option value="all">Todos</option>
            <option value="0-10">0-10 tickets</option>
            <option value="11-50">11-50 tickets</option>
            <option value="51-100">51-100 tickets</option>
            <option value="100+">100+ tickets</option>
          </select>
          <FontAwesomeIcon
            icon="fa-solid fa-chevron-down"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
          />
        </div> */}

        {/* Results Count */}
        <div className="text-sm text-gray-400">
          {filteredAmbassadors.length} embajador
          {filteredAmbassadors.length !== 1 ? "es" : ""} encontrado
          {filteredAmbassadors.length !== 1 ? "s" : ""}
          {selectedAmbassadors.length > 0 && (
            <span className="text-aw-green ml-2">
              ({selectedAmbassadors.length} seleccionado
              {selectedAmbassadors.length !== 1 ? "s" : ""})
            </span>
          )}
        </div>

        {/* Ambassador Grid */}
        <div className="grid grid-cols-2 py-1 sm:grid-cols-3 md:grid-cols-4 gap-3 max-h-[50vh] overflow-y-auto scrollbar-box thin pr-2">
          {filteredAmbassadors.length > 0 ? (
            filteredAmbassadors.map((ambassador) => (
              <AmbassadorCard
                key={ambassador.id}
                ambassador={ambassador}
                isSelected={selectedAmbassadors.some(
                  (a) => a.id === ambassador.id,
                )}
                onToggle={() => onToggle(ambassador)}
                showCheckbox={true}
              />
            ))
          ) : (
            <div className="col-span-full text-center py-8 text-gray-400">
              <FontAwesomeIcon
                icon="fa-solid fa-user-slash"
                className="text-4xl mb-2"
              />
              <p>No se encontraron embajadores</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
